import React from 'react';
import SearchClose from '../assets/images/CloseSmallIcon.svg';

export default () => {
  return <img src={SearchClose} alt="" />;
};
